// Small "opens" badge for the bottom-right edge of a clickable logo, so it's
// clear the logo leads somewhere. Put it inside a `relative group` element;
// it turns cyan when that element is hovered.
export const LinkBadge = ({ className = '-bottom-0.5 -right-0.5' }) => (
  <span
    aria-hidden="true"
    className={`absolute ${className} w-7 h-7 rounded-full bg-jp-band border-2 border-white flex items-center justify-center text-white group-hover:text-cyan-300 transition-colors`}
  >
    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5" />
    </svg>
  </span>
);

export default LinkBadge;
